export enum AppLanguageCode {
  nl = 'nl',
  en = 'en',
  de = 'de',
}

export type SupportedLanguage =
  | AppLanguageCode.nl
  | AppLanguageCode.en
  | AppLanguageCode.de

export const fallbackLng = AppLanguageCode.nl
export const supportedLanguages = ['nl', 'en', 'de']
